const inputPickerOptions: { label: string; value: string }[] = [
  {
    label: 'Pronto socorro',
    value: 'PRONTO_SOCORRO',
  },
  {
    label: 'Ambulatório',
    value: 'AMBULATORIO',
  },
  {
    label: 'Enfermaria',
    value: 'ENFERMARIA',
  },
  {
    label: 'Pediatria',
    value: 'PEDIATRIA',
  },
  {
    label: 'G.O.',
    value: 'GO',
  },
  {
    label: 'Outro',
    value: 'OUTRO',
  },
];

export const topic = { inputPickerOptions };
